export enum USER_QUIZ_GOAL {
  IMPROVE_POSTURE = 'IMPROVE_POSTURE',
  REDUCE_PAIN_AND_TENSION = 'REDUCE_PAINT_AND_TENSION',
  PREVENT_POSTURE_DISORDERS = 'PREVENT_POSTURE_DISORDERS',
  INCREASE_ENERGY_LEVELS = 'INCREASE_ENERGY_LEVELS',
}
